import { RelocationInclusionForm } from "@/app/Relocations/Forms/RelocationInclusionForm";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { DateTimeInput } from "@/lib/Components/Form/Inputs/DateTimeInput";
import { DateInput } from "@/lib/Components/Form/Inputs/DateInput";
import { RichTextInput } from "@/lib/Components/Form/Inputs/RichTextInput";
import { Currency, Measurement } from "@/gql/graphql";
import { SupplierOfficeInput } from "@/app/Offices/Components/SupplierOfficeInput";
import { DistanceAllowedInput } from "@/lib/Components/Form/Inputs/DistanceAllowedInput";
import { VehicleInput } from "@/app/Vehicles/Components/VehicleInput";
import { SupplierInsuranceOptionInput } from "@/app/Suppliers/Components/SupplierInsuranceOptionInput";

export function BookingUpdateDetailsForm({
  currency,
  measurement,
  supplierId,
  showFerryDate,
}: {
  currency: Currency;
  measurement: Measurement;
  supplierId?: string;
  showFerryDate: boolean;
}) {
  return (
    <>
      <TextInput
        autoFocus
        name={"supplier_reference"}
        label={"Supplier reference"}
        className="col-span-4"
      />
      <FormDivider />
      <SupplierOfficeInput
        className="col-span-6"
        name="departureOffice.connect"
        label="Depart From"
        supplierId={supplierId}
      />
      <DateTimeInput
        name={"depart_at"}
        label="Depart at"
        className="col-span-6"
      />

      <SupplierOfficeInput
        className="col-span-6"
        name="deliveryOffice.connect"
        label="Deliver to"
        supplierId={supplierId}
      />
      <DateTimeInput
        name={"deliver_at"}
        label="Deliver at"
        className="col-span-6"
      />

      {showFerryDate ? (
        <DateInput
          name="preferred_ferry_date"
          label="Preferred ferry date"
          className="col-span-6"
        />
      ) : null}

      <FormDivider />

      <VehicleInput
        name="vehicle.connect"
        label="Vehicle"
        className="col-span-6"
        getQueryVariables={(search) => ({
          first: 20,
          page: 1,
          search,
          supplier_id: supplierId,
        })}
        initialFixtureValues={{
          supplier: {
            connect: supplierId ?? null,
          },
        }}
      />
      <SupplierInsuranceOptionInput
        className="col-span-6"
        name="supplierInsuranceOption.connect"
        label="Insurance"
      />

      <DistanceAllowedInput
        className="col-span-6"
        name="distance_allowed"
        label="Mileage"
        measurement={measurement}
        disabled
        tooltip="Mileage is calculated automatically from the relocation and the number of hire days. It cannot be edited directly."
      />

      <RelocationInclusionForm currency={currency} />

      <RichTextInput
        className="col-span-full"
        name="customer_note"
        label="Customer note"
        tooltip="Notes to be displayed on the booking PDF"
      />
    </>
  );
}
